
import { Options, Vue } from "vue-class-component";
import * as data from "../data/data.json";

@Options({
  props: {
    hour: String,
    title: String,
    image: String,
    id: String,
  },
  methods: {
    imageValue: function (value: string) {
      const direction =
        value === "x"
          ? this.transformedImage[0]?.square.x
          : this.transformedImage[0]?.square.y;
      return typeof direction != undefined ? direction * 100 + "%" : "100%";
    },
  },
  computed: {
    styles() {
      return {
        "object-position": `${this.imageValue("x")} ${this.imageValue("y")}`,
      };
    },
  },
})
export default class ScheduleCardByPlace extends Vue {
  hour!: string;
  title!: string;
  image!: string;
  id!: string;
  img =
    // @ts-ignore
    typeof this.image === "string" && this.image.slice(this.image.length - 24);
  transformedImage = data.data.transformedImages.filter((images: any) =>
    images.id.includes(this.img)
  );
}
